import { fork } from '@redux-saga/core/effects';
import { partnersWatcher } from './partnersSaga';

export const watcher = function* () {
  yield fork(partnersWatcher);
};
